import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-comment",
  templateUrl: "./med-icon-comment.component.html",
})
export class MedIconCommentComponent extends SvgMixinComponent {}
